var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelsSms = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 62,
  height: 55,
  viewBox: "0 0 62 55",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M19.336 35.024c0-11.248 10.088-20.318 22.238-19.817l.422.023c13.871.899 23.197 13.842 18.916 26.099l-.11.21c-.358.69-.63 1.295-.857 1.591l1.934 9.909c.189.815-.67 1.799-1.934 1.801h-.017l-.003.001h-.033l-.015-.002c-.21-.025-1.455-.24-10.568-1.8-2.549 1.157-5.59 1.795-8.702 1.801-11.76-.018-21.271-8.9-21.271-19.816M21.27.794c8.445 0 15.814 4.42 19.337 10.81-15.609.523-27.299 13.974-24.172 27.923-1.323.064-2.737-.394-3.867-.9L1.932 40.428c-1.027.202-2.153-.847-1.934-1.801l1.934-9.909C.685 26.427-.001 23.581-.002 20.611 0 9.684 9.622.795 21.27.795"
})));
export default SvgChannelsSms;